export interface Banner {
  _id: string;
  title: string;
  categoryId: {
    _id: string;
    title: string;
  };
  redirectionUrl: string;
  imageUrl: string;
  isMasterClass: boolean;
  masterClassTiming?: string;
  mentorId?: {
    _id: string;
    name: string;
  };
}

export interface BannerResponse {
  success: boolean;
  data: Banner[];
  time_now: string;
}
export interface News {
  _id: string;
  title: string;
  url: string;
  altText: string;
  newsFrom: {
    _id: string;
    name: string;
    description: string;
    companyLogoFileName: string;
  };
  thumbnail: string;
  date: string;
}

export interface NewsData {
  news: News[];
  categoryMeta: {
    phoneNumber: string;
    whatsappLink: string;
    telegramLink: string;
  };
}
export interface NewsResponse {
  _id: string;
  success: boolean;
  status_code: number;
  time_now: string;
  requestId: string;
  data: NewsData;
}

export type SocialLinkValue = string | { url?: string };

export interface ISocialLinks {
  linkedin?: SocialLinkValue;
  youtube?: SocialLinkValue;
  facebook?: SocialLinkValue;
  twitter?: SocialLinkValue;
  instagram?: SocialLinkValue;
}

export const getSocialUrl = (value?: SocialLinkValue): string | undefined =>
  typeof value === 'string' ? value : value?.url;
